import React from "react";
import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IconName } from "@nju/icons";
import { Separator, Text } from "@nju/ui";

interface IStatusProps {
  title: string;
  text: string | React.ReactNode;
  iconName: IconName;
}

interface IGetStatusData {
  orchestrator:
    | IFtthOrchestrator
    | IMobileOrchestrator
    | IMultiOrderOrchestrator
    | IFSecureOrchestrator;
}

export function getStatusData({
  orchestrator,
}: IGetStatusData): IStatusProps | undefined {
  const selectedFailedItem =
    orchestrator.type === "NJU_MULTIORDER_ONBOARDING"
      ? orchestrator?.multiOrderItems?.find((item) => {
          return item.legacy?.feasibilityCode;
        })?.legacy?.feasibilityCode
      : orchestrator.type === "NJU_MOBILE_ONBOARDING" &&
        orchestrator?.legacy?.feasibilityCode;

  if (orchestrator.state === "DELIVERY") {
    return {
      title: "dokończ swoje zamówienie",
      text: "W następnym kroku wybierz typ karty dla swojego zamówienia.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "MNP") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby dokończyć przenoszenie Twojego numeru.",
      iconName: "shopping-bag",
    };
  }

  if (selectedFailedItem && orchestrator.state === "LEGACY_MIGRATION_ERROR") {
    if (selectedFailedItem === "RC001") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: (
          <>
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "l",
              }}
            >
              Korzystasz z oferty Orange, z którą Twój numer połączony jest
              zniżkami, np. Orange Love.
            </Text>
            <Separator size="none" tone="invisible" />
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "l",
              }}
            >
              Zadzwoń na infolinię Orange.
            </Text>
          </>
        ),
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC002") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Wystąpił błąd techniczny.\n Skontaktuj się z nami na czacie, w aplikacji lub na stronie internetowej.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC003") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Ten numer jest zarejestrowany na firmę, dlatego przeniesienie go na konto prywatne nju subskrypcja nie jest możliwe. Zadzwoń na infolinię Orange.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC004") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Dla Twojego numeru mamy już otwarte zlecenie zmiany, włączenia lub wyłączenia usługi.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC005") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Ten numer jest nieaktywny.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC006") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Umowa dla tego numeru kończy się za więcej niż 180 dni.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC007") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Wystąpił błąd techniczny.\n Skontaktuj się z nami na czacie, w aplikacji lub na stronie internetowej.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC008") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Nie możesz przenieść numeru stacjonarnego do nju subskrypcja.",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC009") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Twoje dane nie są kompletne (numer karty SIM, PESEL, numer paszportu \n lub inny dokument).",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC011") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Wystąpił problem ze zgodnością Twoich danych  (PESEL, numer paszportu \n lub inny dokument).",
        iconName: "times-circle",
      };
    }
    if (selectedFailedItem === "RC012") {
      return {
        title: "nie możesz przenieść swojego numeru",
        text: "Wystąpił problem ze zgodnością Twoich danych  (PESEL, numer paszportu \n lub inny dokument).",
        iconName: "times-circle",
      };
    }
  }

  if (
    orchestrator.state === "LEGACY_MIGRATION_PENDING" ||
    orchestrator.state === "LEGACY_MIGRATION" ||
    orchestrator.state === "LEGACY_FEASIBILITY_PENDING"
  ) {
    return {
      title: "dokończ swoje zamówienie",
      text: "Wróć do swojego zamówienia.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "CONTRACT_VERIFICATION") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej i potwierdź, że masz numer w nju mobile.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "IDENTITY") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby potwierdzić swoją tożsamość.",
      iconName: "shopping-bag",
    };
  }

  if (
    orchestrator.state === "IDENTITY_ERROR" &&
    orchestrator.verificationStatusReason === "M09"
  ) {
    return {
      title: "masz mniej niż 18 lat",
      text: "Usługę nju mogą kupić tylko osoby pełnoletnie. Aby móc korzystać z usługi, umowa musi zostać zawarta z osobą powyżej 18 roku życia, np. z Twoim opiekunem, rodzicami czy starszym rodzeństwem.",
      iconName: "exclamation-circle",
    };
  }

  if (orchestrator.state === "IDENTITY_ERROR") {
    return {
      title: "weryfikacja nie powiodła się",
      text: "Spróbuj ponownie – w kolejnym kroku możesz wybrać weryfikację za pomocą banku lub zdjęcia swojego dokumentu.",
      iconName: "exclamation-circle",
    };
  }

  if (orchestrator.state === "ELIGIBILITY_ERROR") {
    return {
      title: "wystąpił problem z Twoim zamówieniem",
      text: "Nie możesz kupić usług na abonament. Wybierz ofertę nju subskrypcja.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "IDENTITY_PENDING") {
    return {
      title: "prawie gotowe",
      text: "Potrzebujemy jeszcze chwili. Zajmie nam to maksymalnie kilka minut. Po pozytywnej weryfikacji Twojej tożsamości automatycznie przeniesiemy Cię do następnego kroku zakupu.",
      iconName: "calendar-alt",
    };
  }

  if (orchestrator.state === "IDENTITY_FULLSTOP") {
    return {
      title: "błędna weryfikacja tożsamości",
      text: "Przekroczono maks. liczbę prób weryfikacji. Skontaktuj się z nami, by rozwiązać ten problem.",
      iconName: "exclamation-circle",
    };
  }

  if (
    orchestrator.state === "PAYMENT_METHOD" &&
    orchestrator.type === "NJU_FTTH_ONBOARDING"
  ) {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby wybrać sposób płatności i dokończyć zamówienie.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "APPOINTMENT") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby wybrać termin instalacji usługi i dokończyć zamówienie.",
      iconName: "shopping-bag",
    };
  }

  if (
    orchestrator.state === "ORDER_SUMMARY" &&
    orchestrator.identityMethodId === "TECHNICALPARTNER" &&
    orchestrator.type === "NJU_MULTIORDER_ONBOARDING" &&
    orchestrator.isUserVerified === false
  ) {
    return {
      title: "weryfikacja tożsamości",
      text: "Masz rozpoczęty proces weryfikacji tożsamości dla innej usługi nju z aplikacją. Czekamy, aż Twoja tożsamość zostanie potwierdzona przez technika. Jest to niezbędne do aktywacji usługi nju subskrypcja.",
      iconName: "sync",
    };
  }

  if (
    orchestrator.type === "NJU_FSECURE_ONBOARDING" &&
    orchestrator.state === "ORDER_SUMMARY"
  ) {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź na podsumowanie zamówienia, aby je dokończyć.",
      iconName: "shopping-bag",
    };
  }

  if (
    orchestrator.type === "NJU_FSECURE_ONBOARDING" &&
    orchestrator.state === "ORDER_COMMITTED"
  ) {
    return {
      title: "zamówienie złożone",
      text: "Przyjęliśmy Twoje zamówienie i je weryfikujemy. Będziemy informować Cię o zmianach statusu.",
      iconName: "sync",
    };
  }

  if (
    orchestrator.type === "NJU_FSECURE_ONBOARDING" &&
    orchestrator.state === "ORDER_PAYMENT"
  ) {
    return {
      title: "oczekiwanie na potwierdzenie płatności",
      text: "Daj nam chwilę. Sprawdzamy, czy płatność została poprawnie zrealizowana.",
      iconName: "sync",
    };
  }

  if (
    orchestrator.type === "NJU_FSECURE_ONBOARDING" &&
    orchestrator.state === "ORDER_FULFILLMENT"
  ) {
    return {
      title: "realizacja w toku",
      text: "Potrzebujemy jeszcze chwili. Zajmie nam to maksymalnie kilka minut.",
      iconName: "sync",
    };
  }

  if (
    orchestrator.type === "NJU_FSECURE_ONBOARDING" &&
    orchestrator.state === "ORDER_PAYMENT_ERROR"
  ) {
    return {
      title: "nie udało się pobrać płatności",
      text: "Nie mogliśmy pobrać płatności za Twoje zamówienie. Aby spróbować ponownie, anuluj zamówienie i rozpocznij proces jeszcze raz.",
      iconName: "exclamation-circle",
    };
  }

  if (orchestrator.state === "ORDER_SUMMARY") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby zapoznać się z podsumowaniem zamówienia i je dokończyć.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "CONSENTS") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby zapoznać się ze zgodami i dokończyć zamówienie.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "AGREEMENT_DATA") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby uzupełnić dane do umowy i dokończyć zamówienie.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "AGREEMENT") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Przejdź dalej, aby zapoznać się z dokumentami i dokończyć zamówienie.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "CUSTOMER_VERIFICATION_PENDING") {
    return {
      title: "prawie gotowe",
      text: "Potrzebujemy jeszcze chwili. Zajmie nam to maksymalnie kilka minut.\nAutomatycznie przeniesiemy Cię do następnego kroku zakupu.",
      iconName: "shopping-bag",
    };
  }

  if (orchestrator.state === "CUSTOMER_VERIFICATION_ERROR") {
    return {
      title: "wystąpił problem z Twoim zamówieniem",
      text: "Nie możesz kupić usług na abonament. Wybierz ofertę nju subskrypcja.",
      iconName: "shopping-bag",
    };
  }

  if (
    (orchestrator.type === "NJU_MULTIORDER_ONBOARDING" ||
      orchestrator.type === "NJU_FSECURE_ONBOARDING") &&
    orchestrator.state === "ORDER_PENDING_CANCELLATION"
  ) {
    return {
      title: "zamówienie w trakcie anulowania",
      text: "Przyjęliśmy zlecenie na anulowanie zamówienia.",
      iconName: "spinner",
    };
  }

  if (
    orchestrator.type !== "NJU_MULTIORDER_ONBOARDING" &&
    orchestrator.state === "ORDER_PENDING_CANCELLATION"
  ) {
    return {
      title: "w trakcie anulowania",
      text: "Potrzebujemy jeszcze chwili na realizację po naszej stronie.",
      iconName: "spinner",
    };
  }

  if (orchestrator.state === "ITEM_SELECTION") {
    return {
      title: "dokończ swoje zamówienie",
      text: "Wybierz, czy chcesz zachować swój obecny numer, czy wybrać nowy.",
      iconName: "shopping-bag",
    };
  }

  if (
    orchestrator.state === "ORDER_CREATION_PENDING" ||
    orchestrator.state === "ORDER_CREATION_ERROR"
  ) {
    return {
      title: "zamówienie złożone",
      text: "Przyjęliśmy Twoje zamówienie i je weryfikujemy - będziemy informować Cię o zmianach statusu.",
      iconName: "shopping-bag",
    };
  }

  return undefined;
}
